module.exports = __webpack_public_path__ + "static/media/gathering.3b35255d.jpg";